<style>
* {
  font-family: "Alegreya Sans", sans-serif;
}
[readonly] {
  cursor: auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
​ button:focus {
  outline: none;
}
.wrapper__viewer {
  background: #fff;
}
.v--modal-overlay:not([data-modal="dialog"]):not([data-modal^="_dynamic_modal"]) {
  background: none;
  width: 0px;
  height: 0px;
}
.modalSelect__layout > .v-menu__content {
  left: 24px !important;
  top: 80px !important;
}
#nav {
  width: calc(100% - 155px);
}
#logo {
  height: 50px;
  width: 145px;
  margin-top: 18px;
}
#logout__icon {
  font-size: 18px;
  margin-left: 5px;
}
.group {
  padding: 0 4px !important;
}
.group .v-input__control label {
  margin-top: 5px;
}
.tab--no_border {
  border-left: 0 !important;
}
.tabs-holder,
.ribbon-menu .tabs-holder li {
  background-color: #304058;
  color: #fff;
  transition: 0.2s;
  border-color: #304058;
}
.ribbon-menu .tabs-holder li:hover {
  background-color: #475b79;
  border-color: #475b79;
}
.ribbon-menu .tabs-holder li.active {
  background-color: #fff;
  color: #000;
  border: 1px solid #dadbdc !important;
}
.ribbon-button {
  height: 100%;
  min-height: 0 !important;
}
.ribbon-button,
.ribbon-tool-button,
.ribbon-icon-button,
.ribbon-button:hover,
.ribbon-tool-button:hover,
.ribbon-icon-button:hover,
.ribbon-button:active {
  border-color: #fff !important;
  background-color: #fff !important;
}
.ribbon-button:hover {
  background-color: #f0f0ed !important;
  transition: 0.2s;
}

.ribbon-button.disabled,
.ribbon-button[disabled],
.ribbon-button:disabled {
  pointer-events: none !important;
  color: darkgrey !important;
}
.ribbon-button.disabled button,
.ribbon-button[disabled] button,
.ribbon-button:disabled button {
  pointer-events: none !important;
  color: darkgrey !important;
}
.ribbon-button.disabled .v-icon,
.ribbon-button[disabled] .v-icon,
.ribbon-button:disabled .v-icon {
  color: darkgrey !important;
}

.section {
  border-bottom: 0;
}
.ribbon_wrapper {
  border-bottom: 1px solid #dadbdc;
  display: flex;
  height: 26px;
}
.wrapper__viewer.expand .ribbon_wrapper {
  height: 109px !important;
}

.nav__expand .v-icon {
  color: #fff !important;
}

nav > ul > li a + ul {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  margin-right: 0;
}
nav > ul > li:hover ul {
  display: block;
  position: fixed !important;
  right: 0 !important;
  top: 24px !important;
}
.more {
  margin-right: 0 !important;
}
.hidden-menu {
  width: 300px;
}
.hidden-menu > li {
  margin-left: 0 !important;
  margin-right: 125px;
}
#btn--logout {
  text-align: center;
  cursor: pointer;
  width: 150px !important;
  float: right;
  background-color: #304058;
  border-bottom: 1px solid #304058;
  margin-left: 5px;
  color: #fff;
  height: 24px;
}
.content-holder {
  width: 100vw !important;
}
.content-holder > div {
  height: 84px !important;
}
.ribbon-menu .tabs-holder a {
  padding: 0 12px !important;
}
.icon {
  margin-right: 5px;
}
.container__group--rows {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 75px;
}
.ribbon-button .icon + .caption {
  margin-top: 0 !important;
}
.btn__first-row {
  border-top: 1px solid #d3d3d3;
}
.ribbon__row--flex {
  display: flex;
  align-items: center;
  max-height: 37.5px;
}
.ribbon__row {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ribbon__row:first-child {
  border-bottom: 1px solid #d3d3d3 !important;
}
/*#loader {
      position:absolute;
      left:50%;
      top:50%;
      z-index:1;
      width:150px;
      height:150px;
      margin:-75px 0 0 -75px;
      border:16px solid #f3f3f3;
      border-radius:50%;
      border-top:16px solid #2a579a;
      border-bottom:16px solid #2a579a;
      -webkit-animation:spin 2s linear infinite;
      animation:spin 2s linear infinite;
  }
  @-webkit-keyframes spin {
      0% {
      -webkit-transform:rotate(0deg);
      }
      100% {
      -webkit-transform:rotate(360deg);
      }
  }
  @keyframes spin {
      0% {
      transform:rotate(0deg);
      }
      100% {
      transform:rotate(360deg);
      }
  }
  .wrapper__viewer {
      opacity:0;
      -webkit-transition:opacity .25s;
      -moz-transition:opacity .25s;
      -ms-transition:opacity .25s;
      -o-transition:opacity .25s;
      transition:opacity .25s;
  }*/
.v-subheader {
  font-size: 16px !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  color: #2a579a;
  font-weight: 700;
}
.modal__content {
  overflow-y: auto !important;
}
.v-btn__content {
  height: 30px;
}
.modal__footer {
  line-height: 50px !important;
  margin-bottom: 0px !important;
}
#ribbon-row__select--base,
#selectStart {
  font-size: 12px;
}
.ribbon__row.border--bottom {
  min-height: 37px;
}

.hidden-menu {
  display: none;
  position: absolute;
  top: 108px;
}
.hidden-menu .hid:not(:last-child) {
  border-bottom: 1px solid lightgrey;
  /* padding-bottom: 10px; */
}
.hidden-menu button {
  width: 100%;
}
#showMore {
  top: 100px;
  height: 24px;
  width: 40px;
  margin-top: 60px;
}
#showMore:hover .hidden-menu {
  display: block;
  position: fixed;
  width: auto;
  background-color: #fff;
  z-index: 100;
}

/*https://binaryify.github.io/vue-custom-scrollbar/en/*/
.v-bar-width {
  width: calc(100% - 156px);
}
.v-bar-width .v-bar-element {
  /*display: flex;*/
  display: -webkit-box;
  position: relative;
}
.v-bar-width .v-bar-element .ps__thumb-x {
  height: 5px;
  bottom: 1px;
  background-color: #2a579a;
}
.v-bar-width .v-bar-element .ps__rail-x.ps--clicking .ps__thumb-x,
.v-bar-width .v-bar-element .ps__rail-x:focus > .ps__thumb-x,
.v-bar-width .v-bar-element .ps__rail-x:hover > .ps__thumb-x {
  height: 8px;
}
.v-bar-width .v-bar-element .ps__rail-x {
  height: 12px;
  /*left: 0px!important;*/
}
.v-bar-width .v-bar-element.ps .ps__rail-x.ps--clicking,
.v-bar-width .v-bar-element.ps .ps__rail-x:focus,
.v-bar-width .v-bar-element.ps .ps__rail-x:hover,
.v-bar-width .v-bar-element.ps .ps__rail-y.ps--clicking,
.v-bar-width .v-bar-element.ps .ps__rail-y:focus,
.v-bar-width .v-bar-element.ps .ps__rail-y:hover {
  background-color: #eee;
  opacity: 0.8;
}

.v-bar-width .v-bar-element .ps--focus > .ps__rail-x,
.v-bar-width .v-bar-element .ps--focus > .ps__rail-y,
.v-bar-width .v-bar-element .ps--scrolling-x > .ps__rail-x,
.v-bar-width .v-bar-element .ps--scrolling-y > .ps__rail-y,
.v-bar-width .v-bar-element.ps:hover > .ps__rail-x,
.v-bar-width .v-bar-element.ps:hover > .ps__rail-y {
  opacity: 0.5;
}
.more-hidden {
  display: none;
}
#geneticDialog {
  z-index: 9999 !important;
}
.bottom-navbar {
  width: 100vw;
  height: 35px;
  padding-top: 5px;
  background: #fff;
  position: fixed;
  z-index: 1;
  border-bottom: 1px solid lightgray;
}
#nav > div.bottom-navbar > div > div:nth-child(6) > div {
  padding-top: 0px;
  max-width: 200px;
}
.bottom-navbar .v-select__selections {
  font-size: 12px;
}

#autocomplete-field-addr,
#autocomplete-field-parcels {
  border-bottom: 1px solid gray;
  margin-left: 10px;
  margin-top: 1px;
  padding-left: 5px;
  height: 20px;
  min-width: 200px;
  line-height: 0.4em;
}
#autocomplete-field-parcels {
  min-width: 280px;
}
#autocomplete-field-addr > input:focus,
#autocomplete-field-parcels > input:focus {
  outline: 0;
}
.autosuggest__results {
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
}
.autosuggest__results-container {
  margin-top: 2px;
  margin-left: -10px;
}
#autosuggest-addr__clear-btn,
#autosuggest-parcels__clear-btn {
  position: absolute;
  z-index: 1;
  font-size: 18px;
  margin-top: 3px;
  top: 3px;
  margin-left: 190px;
}
#autosuggest-parcels__clear-btn {
  margin-left: 270px;
}
ul[role="listbox"] {
  list-style: none;
  margin: 0;
}
ul[role="listbox"] > li:hover {
  background-color: #2a579a;
  color: #ffffff;
}
ul[role="listbox"] > li {
  cursor: pointer;
  transition: all 0.2s;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 12px;
}
.activeBtn {
  background-color: rgba(164, 206, 249, 0.8) !important;
}
#autosuggest__input,
#autosuggest__input-parcels {
  height: 20px !important;
  font-size: 12px !important;
  width: 100%;
}
.ribbon__row {
  justify-content: start;
}
.table__btn--green {
  color: green !important;
}
.table__btn--red {
  color: rgb(217, 0, 0) !important;
}
.table__btn--blue {
  color: #2a579a !important;
}
.table__btn--orange {
  color: #df831f !important;
}
.table__wrapper--center {
  display: flex;
  align-items: center;
}
.table__wrapper--center > p {
  padding-left: 5px;
}
.v-label,
.v-text-field__slot input {
  font-size: 12px !important;
}
.table--first-row {
  border-bottom: 1px solid lightgray !important;
  height: 35px;
}
.table__btn--padding {
  padding-left: 10px;
}
.caption:hover {
  cursor: pointer;
}
.table__wrapper--filter {
  position: relative !important;
  top: -18px !important;
  padding-left: 20px !important;
}
.table__wrapper--center {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.ribbon-button.btn--large {
  margin-top: 7px !important;
}
.group .caption {
  text-transform: uppercase;
}
.accent--text {
  color: #4f7052 !important;
  caret-color: #4f7052 !important;
}
</style>

<template>
  <div>
    <!-- <div id="loader"></div> -->
    <div
      class="wrapper__viewer"
      :class="{expand : expandTabsState}"
    >
      <div class="ribbon_wrapper">
        <nav
          id="nav"
          data-role="ribbonmenu"
        >
          <ul
            id="main"
            class="tabs-holder"
          >
            <li
              class="nav__expand"
              @click="expandTabs"
            >
              <v-icon
                small
                v-if="expandTabsState"
              >expand_less</v-icon>
              <v-icon
                small
                v-else
              >expand_more</v-icon>
            </li>
            <li
              class="nav__start tab--no_border active"
              @click="setNewBookmark('start')"
            >
              <a
                name="start"
                href="#start"
              >START</a>
            </li>
            <!-- <li
              class="nav__edition"
              @click="setNewBookmark('edition')"
            >
              <a
                name="edition"
                href="#edition"
              >EDYCJA</a>
            </li> -->
            <li
              class="nav__analysis"
              @click="setNewBookmark('analysis')"
            >
              <a
                name="analysis"
                href="#analysis"
              >ANALIZY</a>
            </li>
            <li
              class="nav__tasks"
              @click="setNewBookmark('tasks')"
            >
              <a
                name="tasks"
                href="#tasks"
              >ZADANIA</a>
            </li>
            <li
              class="nav__hydrants"
              @click="setNewBookmark('hydrants')"
            >
              <a
                name="hydrants"
                href="#hydrants"
              >HYDRANTY</a>
            </li>
            <li
              class="nav__registers"
              @click="setNewBookmark('registers')"
            >
              <a
                name="registers"
                href="#registers"
              >REJESTRY</a>
            </li>
            <li
              class="nav__watermeters"
              @click="setNewBookmark('watermeters')"
            >
              <a
                name="watermeters"
                href="#watermeters"
              >WODOMIERZE</a>
            </li>
            <li
              class="nav__modelWat"
              title="Model wodociągowy"
              @click="setNewBookmark('modelWat')"
            >
              <a
                name="modelWat"
                href="#modelWat"
              >MODEL WOD</a>
            </li>
            <li
              class="nav__scada"
              @click="setNewBookmark('scada')"
            >
              <a
                name="scada"
                href="#scada"
              >SCADA</a>
            </li>
            <li
              class="nav__servitude"
              @click="setNewBookmark('servitude')"
            >
              <a
                name="servitude"
                href="#servitude"
              >SŁUŻEBNOŚĆ</a>
            </li>
            <li
              class="nav__management"
              @click="setNewBookmark('management')"
            >
              <a
                name="management"
                href="#management"
              >ZARZĄDZANIE</a>
            </li>
            <li
              class="nav__video"
              @click="setNewBookmark('video')"
            >
              <a
                name="video"
                href="#video"
              >WIDEO</a>
            </li>
            <li
              class="nav__settings"
              @click="setNewBookmark('settings')"
            >
              <a
                name="settings"
                href="#settings"
              >USTAWIENIA</a>
            </li>
            <li
              class="more hidden"
              data-width="100"
              @click.prevent
            >
              <a href="#">
                <span class="fa fa-ellipsis-h"></span>
              </a>
              <ul class="hidden-menu"></ul>
            </li>
          </ul>

          <div
            class="content-holder"
            style="background-color: white;"
            v-show="expandTabsState"
          >
            <div
              class="section v-bar-width"
              id="start"
            >
              <Start
                v-if="this.$store.getters.getCurrentBookmark == 'start'"
                ref="start"
              />
            </div>
            <div
              class="section v-bar-width"
              id="edition"
            >
              <Edition
                v-if="this.$store.getters.getCurrentBookmark == 'edition'"
                ref="edition"
              />
            </div>
            <div
              class="section v-bar-width"
              id="analysis"
            >
              <Analysis
                v-if="this.$store.getters.getCurrentBookmark == 'analysis'"
                ref="analysis"
              />
            </div>
            <!-- Zadania -->
            <div
              class="section v-bar-width"
              id="tasks"
            >
              <Tasks
                v-if="this.$store.getters.getCurrentBookmark == 'tasks'"
                ref="tasks"
                @showTasksFilter="toggleTasksFilter(true)"
                @hideTasksFilter="toggleTasksFilter(false)"
              />
            </div>
            <div
              class="section v-bar-width"
              id="hydrants"
            >
              <Hydrants
                v-if="this.$store.getters.getCurrentBookmark == 'hydrants'"
                ref="hydrants"
              />
            </div>
            <div
              class="section v-bar-width"
              id="registers"
            >
              <Registers
                v-if="this.$store.getters.getCurrentBookmark == 'registers'"
                ref="registers"
              />
            </div>
            <div
              class="section v-bar-width"
              id="watermeters"
            >
              <Watermeters
                v-if="this.$store.getters.getCurrentBookmark == 'watermeters'"
                ref="watermeters"
              />
            </div>
            <div
              class="section v-bar-width"
              id="modelWat"
            >
              <ModelWat
                v-if="this.$store.getters.getCurrentBookmark == 'modelWat'"
                ref="modelWat"
              />
            </div>
            <div
              class="section v-bar-width"
              id="scada"
            >
              <Scada
                v-if="this.$store.getters.getCurrentBookmark == 'scada'"
                ref="scada"
              />
            </div>
            <div
              class="section v-bar-width"
              id="servitude"
            >
              <Servitude
                v-if="this.$store.getters.getCurrentBookmark == 'servitude'"
                ref="servitude"
                @showServitudesFilter="toggleServitudesFilter(true)"
                @hideServitudesFilter="toggleServitudesFilter(false)"
              />
            </div>
            <div
              class="section v-bar-width"
              id="management"
            >
              <Management
                v-if="this.$store.getters.getCurrentBookmark == 'management'"
                ref="management"
                @showInvestFilter="toggleInvestFilter(true)"
                @hideInvestFilter="toggleInvestFilter(false)"
              />
            </div>
            <div
              class="section v-bar-width"
              id="video"
            >
              <Video
                v-if="this.$store.getters.getCurrentBookmark == 'video'"
                ref="video"
              />
            </div>
            <div
              class="section v-bar-width"
              id="settings"
            >
              <Settings
                v-if="this.$store.getters.getCurrentBookmark == 'settings'"
                ref="settings"
              />
            </div>
          </div>
          <div class="bottom-navbar">
            <v-layout>
              <div style="padding-left: 10px;">
                <v-icon
                  @click="show('legendModal')"
                  title="Legenda mapy"
                >layers</v-icon>
              </div>
              <div style="padding-left: 5px;">
                <v-icon
                  @click="akcjaOtworzTabeleDanych"
                  :class="{activeBtn : tableDataActive}"
                  title="Otwórz tabelę atrybutów"
                >table_chart</v-icon>
              </div>
              <div style="padding-top:0;padding-left: 5px;padding-bottom:0">
                <v-icon
                  @click="show('printModal')"
                  title="Drukuj"
                >print</v-icon>
              </div>
              <div style="padding-left: 5px;">
                <v-icon
                  @click="labelsVisibleToggle"
                  :class="{activeBtn : labelsShow}"
                  title="Widoczność etykiet"
                >font_download</v-icon>
              </div>
              <div style="padding-left: 5px; padding-right: 5px;">
                <v-icon
                  @click="toggleStreetView"
                  :class="{active: streetViewSelection}"
                  title="Włącz streetview"
                >streetview</v-icon>
              </div>

              <div>
                <v-select
                  :items="baselayers"
                  item-text="display_name"
                  :return-object="true"
                  v-model="currentBasemap"
                  no-data-text="Brak warstw"
                  height="16"
                  placeholder="Warstwy podkładowe"
                  id="ribbon-row__select--base"
                  class="attach-select"
                ></v-select>
              </div>
              <div
                class="text-center"
                style="margin-top: -6px;"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#304058"
                      dark
                      small
                      depressed
                      v-on="on"
                      style="height: 22px"
                    >
                      PRZEZROCZYSTOŚĆ
                    </v-btn>
                  </template>
                  <v-list>
                    <v-slider
                      v-model="basemapOpacity"
                      style="padding-left:15px;padding-right:15px;"
                      persistent-hint
                      :hint="`Krycie: ${basemapOpacity} %`"
                    ></v-slider>
                  </v-list>
                </v-menu>
              </div>
              <div>
                <vue-autosuggest
                  :suggestions="[{data:autocompleteListLabels}]"
                  @selected="showAddress"
                  :input-props="{id:'autosuggest__input', onInputChange: onInputChange, placeholder:'WYSZUKAJ ADRES'}"
                  id="autocomplete-field-addr"
                  ref="autosuggestInput"
                >
                  <template slot-scope="{suggestion}">
                    <span class="my-suggestion-item">{{suggestion.item}}</span>
                  </template>
                </vue-autosuggest>
                <v-icon
                  id="autosuggest-addr__clear-btn"
                  @click="clearAutosuggest('addr')"
                  title="Wyczyść wyszukiwanie"
                  v-if="clearAddrVisible"
                >delete</v-icon>
              </div>
              <div>
                <vue-autosuggest
                  :suggestions="[{data:autocompleteListLabelsParcels}]"
                  @selected="showAddressParcel"
                  :input-props="{id:'autosuggest__input-parcels', onInputChange: onInputChangeParcel, placeholder:'WYSZUKAJ DZIAŁKĘ'}"
                  id="autocomplete-field-parcels"
                  ref="autosuggestInputParcels"
                >
                  <template slot-scope="{suggestion}">
                    <span class="my-suggestion-item-parcel">{{suggestion.item}}</span>
                  </template>
                </vue-autosuggest>
                <v-icon
                  id="autosuggest-parcels__clear-btn"
                  @click="clearAutosuggest('parcel')"
                  title="Wyczyść wyszukiwanie"
                  v-if="clearParcelsVisible"
                >delete</v-icon>
              </div>
              <div
                class="text-center"
                style="margin-top: -6px;"
                v-if="isInvestFilterVisible"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#304058"
                      dark
                      small
                      depressed
                      v-on="on"
                      style="height: 22px"
                    >
                      FILTR INWESTYCJI
                    </v-btn>
                  </template>
                  <v-list style="padding: 0px;">
                    <v-container style="padding: 12px;">
                      <template v-for="status in statuses">
                        <span
                          @click.stop
                          :key="status"
                          style="display: flex;"
                        >
                          <v-checkbox
                            style="margin-top:0px"
                            @change="changeInvestmentLayers"
                            v-model="selectedStatuses"
                            :value="status"
                            :label="status"
                          ></v-checkbox>
                          <v-chip
                            :color="mapColors[status].fill"
                            text-color="white"
                            style="height: 24px;"
                          ></v-chip>
                        </span>
                      </template>
                    </v-container>
                  </v-list>
                </v-menu>
              </div>
              <div
                class="text-center"
                style="margin-top: -6px;"
                v-if="isTasksFilterVisible"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#304058"
                      dark
                      small
                      depressed
                      v-on="on"
                      style="height: 22px"
                      @click="showTasksFilters"
                    >
                      FILTR ZADANIA
                    </v-btn>
                  </template>
                  <v-list style="padding: 0px;">
                    <v-container
                      @click.stop
                      style="padding: 12px;"
                    >
                      <v-select
                        :items="taskTypes"
                        v-model="selectedTaskType"
                        label="Typ zadania"
                        style="font-size:12px"
                        @change="filterTasksTypes"
                        clearable
                      ></v-select>
                      <span v-if="selectedTaskType">
                        <template v-for="status in taskStatuses">
                          <span
                            @click.stop
                            :key="status"
                            style="display: flex;"
                          >
                            <v-checkbox
                              style="margin-top:0px"
                              @change="changeTaskLayers"
                              v-model="selectedTaskStatuses"
                              :value="status"
                              :label="status"
                            ></v-checkbox>
                            <v-chip
                              :color="mapColors[status].fill"
                              text-color="white"
                              style="height: 24px;"
                            ></v-chip>
                          </span>
                        </template>
                      </span>
                    </v-container>
                  </v-list>
                </v-menu>
              </div>

              <div
                class="text-center"
                style="margin-top: -6px;"
                v-if="isServitudesFilterVisible"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="#304058"
                      dark
                      small
                      depressed
                      v-on="on"
                      style="height: 22px"
                    >
                      FILTR SŁUŻEBNOŚCI
                    </v-btn>
                  </template>
                  <v-list style="padding: 0px;">
                    <v-container
                      @click.stop
                      style="padding: 12px;"
                    >
                      <v-select
                        :items="servitudeClasses"
                        item-text="displayName"
                        item-value="name"
                        :return-object="true"
                        v-model="selectedServitudeClass"
                        label="Klasyfikuj na postawie"
                        style="font-size:12px"
                        @change="filterServitudesClasses"
                        clearable
                      ></v-select>
                      <span v-if="selectedServitudeClass && selectedServitudeClass.name == 'status'">
                        <template v-for="status in servitudeStatuses">
                          <span
                            @click.stop
                            :key="status"
                            style="display: flex;"
                          >
                            <v-checkbox
                              style="margin-top:0px"
                              @change="changeServitudeLayers"
                              v-model="selectedServitudeStatuses"
                              :value="status"
                              :label="status"
                            ></v-checkbox>
                            <v-chip
                              :color="mapColors[status].fill"
                              text-color="white"
                              style="height: 24px;"
                            ></v-chip>
                          </span>
                        </template>
                      </span>
                      <span v-if="selectedServitudeClass && selectedServitudeClass.name == 'owner_type'">
                        <template v-for="status in servitudeStatuses">
                          <span
                            @click.stop
                            :key="status"
                            style="display: flex;"
                          >
                            <v-checkbox
                              style="margin-top:0px"
                              @change="changeServitudeLayers"
                              v-model="selectedServitudeStatuses"
                              :value="status"
                              :label="status"
                            ></v-checkbox>
                            <v-chip
                              :color="mapColors[status].fill"
                              text-color="white"
                              style="height: 24px;"
                            ></v-chip>
                          </span>
                        </template>
                      </span>
                    </v-container>
                  </v-list>
                </v-menu>
              </div>
            </v-layout>
          </div>
        </nav>
        <span style="display: flex; flex-direction:column; align-items: center; z-index: 1">
          <div
            @click="logout"
            id="btn--logout"
            title="Wyloguj się"
          >
            <span class="icon">
              <v-icon style="font-size: 20px; color:#fff;">power_settings_new</v-icon>
            </span>
            <span>{{username | lengthControl}}</span>
          </div>
          <img
            id="logo"
            v-show="expandTabsState"
            :src="require('@/logo.jpg')"
          >
        </span>
      </div>

      <!--Tutaj umieszczamy otwierane modale z innych komponentów,aby nie znikały podczas przełączania tabów. -->
      <v-dialog
        id="geneticDialog"
        transition="fade"
        :width="dialogWidth"
        :click-to-close="false"
      />
      <modals-container />
      <Identification />
      <SettingsSnap />
      <AttributesElementEditing />
      <DataImportModal />
      <!-- Analizy -->
      <GenerateRaport />
      <GenerateAd />
      <ProfileNMT />
      <ProfileSW />
      <ExportStats />
      <SendSMS />
      <ValvesStateLegend />
      <!-- Hydranty -->
      <HydrantsRegister />
      <HydrantCard />
      <PrintHydrantCard />
      <InspectionsRegister />
      <InspectionCard />
      <AddInspectionCard />
      <!-- <TasksRegister /> -->
      <!-- Modelowanie wod -->
      <ModelingParameters />
      <ExportGraph />
      <CheckGraphResults />
      <AddProjectedReceiver />
      <DisplaySettings />
      <EditProjectedReceiver />
      <ModelingLegend />
      <VirtualRecipientsRegister />
      <ModellingError />
      <CurvesModal />
      <CurveDetail />
      <AddCurvePattern />
      <EpanetControls />

      <!-- Służebność -->
      <ServitudeCard />
      <ServitudeChanges />
      <ServitudeRegister />
      <ServitudeSymbology />
      <AddServitude />
      <!-- Ustawienia -->
      <Dictionaries />
      <LoginSettings />
      <UserAttributes />
      <AddUserAttribute />
      <EventBrowser />
      <UsersTable />
      <AddUser />
      <AddGroup />
      <ChangePasswordUser />
      <ChangeUserGroup />
      <ModifyPermissions />
      <AssignUserGroup />
      <IconStyleUploader />
      <HistoryChanges />
      <HistoryChangesDetails />
      <SharedViewModal />
      <!-- Inspekcja wideo -->
      <Profile />
      <AddVideoInspectionCard />
      <VideoInspectionCard />
      <VideoRegister />
      <VideoReportSettings />
      <!-- Start -->
      <MapLegend />
      <DEMLegend />
      <ModifyLayerStyle />
      <AddBookmark />
      <TerminalsRegister />
      <TerminalCard />
      <AttachmentsRegister />
      <AddAttachmentstoObjects />
      <AddRaster />
      <NetworkReport />
      <!-- Edycja -->
      <NewUserLayer />
      <AddNewField />
      <LayersJoin />
      <LayersJoinOptions />
      <CopyPastFeatures />
      <!-- Wodomierze -->
      <PrwRegister />
      <PrwCard />
      <WatermetersRegister />
      <WatermeterCard />
      <!-- Zadania (tasks) -->
      <TaskCard />
      <TasksRegister />
      <!-- Variances -->
      <VariancesRegister />
      <AddVariance />
      <VarianceCard @confDialogOpened="triggerDialog" />
      <!-- Events -->
      <AddEvent />
      <!-- Docs -->
      <AcceptanceRegister />
      <ProcessRegister />
      <DocumentationRegister />
      <TechnicalPreconditionsRegister />
      <ApplicationsRegister />
      <InvestmentsRegister />
      <InvestmentCard />
      <AddInvestmentCard />

      <!-- Scada
      <AddScadaPoint />
      <AddMeasuringSeries />-->
      <ScadaSettings />

      <MeasureTools />
      <Map ref="mapComponent" />
      <Snackbar />
      <Print />
      <FeatureCard />

      <DataAttributionsTable />
      <SimpleDataAttributionsTable />
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import _ from "lodash/wrapperLodash";
import {VueAutosuggest} from "vue-autosuggest";

import Map from "./map/Map";
import MeasureTools from "./measureTools/MeasureTools";
import Snackbar from "../shared/Snackbar";
import Print from "../shared/Print";
import AddEvent from "../shared/AddEvent";
import FeatureCard from "../shared/FeatureCard";

import Settings from "./settings/Settings";
import Analysis from "./analysis/Analysis";
import Start from "./start/Start";
import Edition from "./edition/Edition";
import Hydrants from "./hydrants/Hydrants";
import Registers from "./registers/Registers";
import Watermeters from "./watermeters/Watermeters";
import Tasks from "./tasks/Tasks";
import Management from "./management/Management";
import ModelWat from "./modelWat/ModelWat";
import Scada from "./scada/Scada";
import Servitude from "./servitude/Servitude";
import Video from "./video/Video";


// Komponenty z innych modali
// Awarie

// Wodomierze
import PrwRegister from "./watermeters/modals/PrwRegister.vue";
import PrwCard from "./watermeters/modals/PrwCard.vue";
import WatermetersRegister from "./watermeters/modals/WatermetersRegister.vue";
import WatermeterCard from "./watermeters/modals/WatermeterCard.vue";

// Analizy
import GenerateRaport from "./analysis/modals/GenerateRaport";
import GenerateAd from "./analysis/modals/GenerateAd";
import ProfileNMT from "./analysis/modals/ProfileNMT";
import ProfileSW from "./analysis/modals/ProfileSW";
import ExportStats from "./analysis/modals/ExportStats";
import SendSMS from "./analysis/modals/SendSMS";
import ValvesStateLegend from "./analysis/modals/ValvesStateLegend";
// Hydranty
import HydrantsRegister from "./hydrants/modals/hydrants/HydrantsRegister";
import HydrantCard from "./hydrants/modals/hydrants/HydrantCard";
import PrintHydrantCard from "./hydrants/modals/hydrants/PrintHydrantCard";
import InspectionsRegister from "./hydrants/modals/inspections/InspectionsRegister";
import InspectionCard from "./hydrants/modals/inspections/InspectionCard";
import AddInspectionCard from "./hydrants/modals/inspections/AddInspectionCard";
// Modelowanie wod
import ModelingParameters from "./modelWat/modals/ModelingParameters";
import ExportGraph from "./modelWat/modals/ExportGraph";
import CheckGraphResults from "./modelWat/modals/CheckGraphResults";
import DisplaySettings from "./modelWat/modals/DisplaySettings";
import AddProjectedReceiver from "./modelWat/modals/AddProjectedReceiver";
import EditProjectedReceiver from "./modelWat/modals/EditProjectedReceiver";
import ModelingLegend from "./modelWat/modals/ModelingLegend";
import VirtualRecipientsRegister from "./modelWat/modals/VirtualRecipientsRegister";
import ModellingError from "./modelWat/modals/ModellingError";
import CurvesModal from "./modelWat/modals/CurvesModal";
import CurveDetail from "./modelWat/modals/CurveDetail";
import AddCurvePattern from "./modelWat/modals/AddCurvePattern";
import EpanetControls from "./modelWat/modals/EpanetControls";

// Służebność
import ServitudeCard from "./servitude/modals/ServitudeCard";
import ServitudeChanges from "./servitude/modals/ServitudeChanges";
import ServitudeRegister from "./servitude/modals/ServitudeRegister";
import ServitudeSymbology from "./servitude/modals/ServitudeSymbology";
import AddServitude from "./servitude/modals/AddServitudeModal";

// Ustawienia
import Dictionaries from "./settings/modals/dictionaries/Dictionaries";
import LoginSettings from "./settings/modals/loginSettings/LoginSettings";
import UserAttributes from "./settings/modals/userAttributes/UserAttributes";
import AddUserAttribute from "./settings/modals/userAttributes/AddUserAttribute";
import EventBrowser from "./settings/modals/eventBrowser/EventBrowser";
import UsersTable from "./settings/modals/userManagement/Users";
import AddUser from "./settings/modals/userManagement/AddUser";
import AddGroup from "./settings/modals/userManagement/AddGroup";
import ChangePasswordUser from "./settings/modals/userManagement/ChangePasswordUser";
import ModifyPermissions from "./settings/modals/userManagement/ModifyPermissions";
import AssignUserGroup from "./settings/modals/userManagement/AssignUserGroup";
import ChangeUserGroup from "./settings/modals/userManagement/ChangeUserGroup";
import IconStyleUploader from "./settings/modals/IconStyleUploader";
import HistoryChanges from "./settings/modals/HistoryChanges";
import HistoryChangesDetails from "./settings/modals/HistoryChangesDetails";
import SharedViewModal from "./settings/modals/SharedViewModal";
import DataImportModal from "./settings/modals/DataImportModal";
// Inspekcja wideo
import VideoInspectionCard from "./video/modals/VideoInspectionCard";
import AddVideoInspectionCard from "./video/modals/AddVideoInspectionCard";
import VideoRegister from "./video/modals/VideoRegister";
import Profile from "./video/modals/Profile";
import VideoReportSettings from "./video/modals/VideoReportSettings";
// Start
import AddBookmark from "./start/modals/AddBookmark";
import MapLegend from "./start/modals/MapLegend";
import DEMLegend from "./start/modals/DEMLegend";
import ModifyLayerStyle from "./start/modals/ModifyLayerStyle";
import TerminalsRegister from "./start/modals/terminals/TerminalsRegister";
import TerminalCard from "./start/modals/terminals/TerminalCard";
import AddAttachmentstoObjects from "../shared/AddAttachmentsToObjects";
import AttachmentsRegister from "./registers/AttachmentsRegister";
import AddRaster from "./start/modals/AddRaster";
import NetworkReport from "./start/modals/NetworkReport";
// import CommonComp from "../shared/CommonComp";
// Variances
import VariancesRegister from "./start/modals/variances/VariancesRegister";
import AddVariance from "./start/modals/variances/AddVariance";
import VarianceCard from "./start/modals/variances/VarianceCard";
// Zadania (tasks)
import TaskCard from "./tasks/modals/TaskCard";
import TasksRegister from "./tasks/modals/TasksRegister";
// Scada
// import AddScadaPoint from "./scada/modals/AddScadaPoint";
import ScadaSettings from "./scada/modals/ScadaSettings";
// import AddMeasuringSeries from "./scada/modals/AddMeasuringSeries";

import Identification from "./map/modals/Identification";

// Edycja
import AddNewField from "./edition/modals/AddNewField";
import SettingsSnap from "./edition/modals/SettingsSnap";
import LayersJoin from "./edition/modals/LayersJoin";
import AttributesElementEditing from "./edition/modals/AttributesElementEditing";
import DataAttributionsTable from "./edition/panels/DataAttributionsTable";
import SimpleDataAttributionsTable from "./edition/panels/SimpleDataAttributionsTable";
import NewUserLayer from "./edition/modals/NewUserLayer";
import LayersJoinOptions from "./edition/modals/LayersJoinOptions";
import CopyPastFeatures from "./edition/modals/CopyPastFeatures";

// Dokumenty
import AcceptanceRegister from "./management/modals/AcceptanceRegister";
import ProcessRegister from "./management/modals/ProcessRegister";
import DocumentationRegister from "./management/modals/DocumentationRegister";
import TechnicalPreconditionsRegister from "./management/modals/TechnicalPreconditionsRegister";
import ApplicationsRegister from "./management/modals/ApplicationsRegister";
import InvestmentsRegister from "./management/modals/InvestmentsRegister";
import InvestmentCard from "./management/modals/InvestmentCard";
import AddInvestmentCard from "./management/modals/AddInvestmentCard";

export default {
  data: () => ({
    username: "",
    isConfDialogActive: false,
    autocompleteList: [],
    autocompleteListLabels: [],
    autocompleteListParcels: [],
    autocompleteListLabelsParcels: [],
    autocompleteFieldContent: "",
    dialogWidth: 400,
    mapColors: {
      'Przyjęto wniosek': {
        'fill': 'rgba(255, 213, 0, 0.7)',
        'stroke': 'rgba(255, 213, 0, 1)',
      },
      'Wydano warunki': {
        'fill': 'rgba(66, 135, 245, 0.7)',
        'stroke': 'rgba(66, 135, 245, 1)',
      },
      'Odpowiedź odmowna': {
        'fill': 'rgba(235, 64, 52, 0.7)',
        'stroke': 'rgba(235, 64, 52, 1)',
      },
      'Przyjęto projekt': {
        'fill': 'rgba(63, 163, 0, 0.7)',
        'stroke': 'rgba(63, 163, 0, 1)',
      },
      'W trakcie inwestycji': {
        'fill': 'rgba(168, 0, 160, 0.7)',
        'stroke': 'rgba(168, 0, 160, 1)',
      },
      'Inwestycja odebrana': {
        'fill': 'rgba(168, 101, 0, 0.7)',
        'stroke': 'rgba(168, 101, 0, 1)',
      },
      'Inwestycja nieodebrana': {
        'fill': 'rgba(110, 89, 57, 0.7)',
        'stroke': 'rgba(110, 89, 57, 1)',
      },
      'Inne': {
        'fill': 'rgba(57, 26, 110, 0.7)',
        'stroke': 'rgba(57, 26, 110, 1)',
      },
      'Nowe': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(235, 64, 52, 1)',
      },
      'Zaplanowane': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(255, 213, 0, 1)',
      },
      'Zlecone wykonanie': {
        'fill': 'rgba(168, 0, 160, 0.5)',
        'stroke': 'rgba(168, 0, 160, 1)',
      },
      'W trakcie': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(66, 135, 245, 1)',
      },
      'Zakończone': {
        'fill': 'rgba(63, 163, 0, 0.5)',
        'stroke': 'rgba(63, 163, 0, 1)',
      },
      'ustanowiona': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(189, 158, 0, 1)',
      },
      'w trakcie ustanawiania': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(7, 57, 138, 1)',
      },
      'nieustanowiona': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(145, 19, 10, 1)',
      },
      'Osoba fizyczna': {
        'fill': 'rgba(255, 213, 0, 0.5)',
        'stroke': 'rgba(189, 158, 0, 1)',
      },
      'Skarb Państwa': {
        'fill': 'rgba(66, 135, 245, 0.5)',
        'stroke': 'rgba(7, 57, 138, 1)',
      },
      'Województwo': {
        'fill': 'rgba(235, 64, 52, 0.5)',
        'stroke': 'rgba(145, 19, 10, 1)',
      },
      'Powiat': {
        'fill': 'rgba(63, 163, 0, 0.5)',
        'stroke': 'rgba(35, 82, 5, 1)',
      },
      'Gmina': {
        'fill': 'rgba(168, 0, 160, 0.5)',
        'stroke': 'rgba(97, 4, 92, 1)',
      },
      'Osoba prawna': {
        'fill': 'rgba(168, 101, 0, 0.5)',
        'stroke': 'rgba(115, 72, 7, 1)',
      },
      'Spółdzielnie': {
        'fill': 'rgba(110, 89, 57, 0.5)',
        'stroke': 'rgba(56, 44, 26, 1)',
      },
      'Brak danych': {
        'fill': 'rgba(181, 169, 138, 0.5)',
        'stroke': 'rgba(117, 110, 91, 1)',
      },
    },
    streetViewSelection: false,
    expandTabsState: true,
    clearAddrVisible: false,
    clearParcelsVisible: false,
    isInvestFilterVisible: false,
    isTasksFilterVisible: false,
    statuses: [],
    selectedStatuses: [],
    selectedTaskTypes: [],
    selectedTaskStatuses: ["Nowe", "Zaplanowane", "Zlecone wykonanie", "W trakcie", "Zakończone"],
    selectedTaskType: undefined,
    taskStatuses: ["Nowe", "Zaplanowane", "Zlecone wykonanie", "W trakcie", "Zakończone"],
    taskTypes: [],
    // służebność
    isServitudesFilterVisible: false,
    servitudeClasses: [
      {
        displayName: "Status służebności",
        name: "status"
      },
      {
        displayName: "Typ właściciela",
        name: "owner_type"
      }
    ],
    selectedServitudeClass: undefined,
    selectedServitudeStatuses: [],
    servitudeStatuses: []
  }),
  components: {
    Map,
    VueAutosuggest,
    MeasureTools,
    Settings,
    Analysis,
    Edition,
    Hydrants,
    Registers,
    Watermeters,
    Management,
    ModelWat,
    Scada,
    Servitude,
    Snackbar,
    Start,
    Tasks,
    Video,
    Print,
    FeatureCard,
    // Komponenty z innych modali
    //Analizy
    GenerateRaport,
    GenerateAd,
    ProfileNMT,
    ProfileSW,
    ExportStats,
    SendSMS,
    ValvesStateLegend,
    // Hydranty
    HydrantsRegister,
    HydrantCard,
    PrintHydrantCard,
    InspectionsRegister,
    AddInspectionCard,
    InspectionCard,
    // Modal wod
    ModelingParameters,
    ExportGraph,
    CheckGraphResults,
    DisplaySettings,
    AddProjectedReceiver,
    EditProjectedReceiver,
    ModelingLegend,
    VirtualRecipientsRegister,
    ModellingError,
    CurvesModal,
    CurveDetail,
    AddCurvePattern,
    EpanetControls,
    // Służebność
    ServitudeCard,
    ServitudeChanges,
    ServitudeRegister,
    ServitudeSymbology,
    AddServitude,
    // Ustawienia
    Dictionaries,
    LoginSettings,
    UserAttributes,
    AddUserAttribute,
    EventBrowser,
    UsersTable,
    AddUser,
    AddGroup,
    AssignUserGroup,
    ChangeUserGroup,
    IconStyleUploader,
    HistoryChanges,
    HistoryChangesDetails,
    SharedViewModal,
    // Inspekcja wideo
    AddVideoInspectionCard,
    Profile,
    VideoInspectionCard,
    VideoRegister,
    VideoReportSettings,
    // Start
    AddBookmark,
    MapLegend,
    DEMLegend,
    ModifyLayerStyle,
    TerminalsRegister,
    TerminalCard,
    AttachmentsRegister,
    AddAttachmentstoObjects,
    NetworkReport,
    // CommonComp,
    AddEvent,
    AddRaster,
    ChangePasswordUser,
    ModifyPermissions,
    // Variances
    VariancesRegister,
    AddVariance,
    VarianceCard,
    // Scada
    // AddScadaPoint,
    ScadaSettings,
    //AddMeasuringSeries
    Identification,
    SettingsSnap,
    DataImportModal,
    AttributesElementEditing,
    DataAttributionsTable,
    SimpleDataAttributionsTable,
    // Edycja
    AddNewField,
    NewUserLayer,
    LayersJoin,
    LayersJoinOptions,
    CopyPastFeatures,
    // Wodomierze
    PrwRegister,
    PrwCard,
    WatermetersRegister,
    WatermeterCard,
    // Zadania (tasks)
    TaskCard,
    TasksRegister,
    // Dokumenty
    AcceptanceRegister,
    ProcessRegister,
    DocumentationRegister,
    TechnicalPreconditionsRegister,
    ApplicationsRegister,
    InvestmentsRegister,
    InvestmentCard,
    AddInvestmentCard
  },
  mounted() {
    const self = this;
    self.username = localStorage.username;
    self.$store.dispatch("getBookmarks");
    self.$store.dispatch("getLayers");
    self.$store.dispatch("getSettings");

    self.$root.$on("dialogWidth", (value = false) => this.dialogWidth = value ? value : 400);

    // equivalent jQuery .ready()
    if(document.readyState !== "loading") {
      setTimeout(() => {
        self.calcWidth();
      }, 1000);
      //self.calcWidthRibbon();
    }

    window.addEventListener("resize", e => {
      self.calcWidth();
      //self.calcWidthRibbon();
      self.calcWidthRibbonScroll();
    });
    this.$root.$on("passStreetViewCoords", this.openStreetView);

    //self.$root.$on('calcWidthRibbon', self.calcWidthRibbon);

    let payloadStatuses = {
      schema: "investments",
      table: "investments",
      column: "status"
    }
    this.$store.dispatch('getDictSTC', payloadStatuses).then(r => {
      this.statuses = r.values;
      this.selectedStatuses = r.values;
    });

    /* let payloadStatusesTasks = {
      schema: "registry",
      table: "tasks",
      column: "task_type"
    }
    this.$store.dispatch('getDictSTC', payloadStatusesTasks).then(r => {
      this.taskStatuses = r.values;
      this.selectedTaskStatuses = r.values;
    }); */
  },
  filters: {
    lengthControl: value => {
      value = (value || "").toString();
      if(value.length > 14) {
        return `${value.substring(0, 11)}...`;
      }
      return value;
    }
  },
  computed: {
    basemapOpacity: {
      get() {
        return this.$store.getters.getBasemapOpacity;
      },
      set(val) {
        this.$store.commit('setBasemapOpacity', val);
        this.$root.$emit('setBasemapOpacity', val);
      }
    },
    currentBasemap: {
      get() {
        return this.$store.getters.getCurrentBasemap;
      },
      set(value) {
        this.$root.$emit("switchBasemapByName", value.display_name);
        this.$store.commit("setCurrentBasemap", value.display_name);
      }
    },
    currentRibbonBookmark() {
      return this.$store.getters.getCurrentBookmark;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    baselayers() {
      return this.$store.getters.getBaselayers;
    },
    labelsShow() {
      return this.$store.getters.getLabelsShow;
    },
    map() {
      return this.$store.getters.getMap;
    },
    tableDataActive() {
      return this.$store.getters.getTableDataActive;
    },
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    showTasksFilters() {
      if(this.taskTypes.length == 0) {
        let payload = {
          schema: 'registry',
          table: 'tasks',
          column: 'task_type',
          'with-subdicts': false
        };
        this.$store.dispatch("getDictSTC", payload).then(r => {
          if(!r) {
            return;
          } else {
            this.taskTypes = r.values;
            this.$root.$emit('setTasksVisibility', [r.values[0], false]);
          }
        });
      }
    },
    showServitudeFilters() {
      if(this.servitudeClasses.length == 0) {
        let payload = {
          schema: 'registry',
          table: 'transmission_easement',
          column: 'owner_type',
          'with-subdicts': false
        };
        this.$store.dispatch("getDictSTC", payload).then(r => {
          if(!r) {
            return;
          } else {
            this.servitudeClasses = r.values;
            // this.$root.$emit('setTasksVisibility', [r.values[0], false]);
          }
        });
      }
    },
    changeInvestmentLayers(selectedLayers) {
      let layers = ["Wydano warunki", "Odpowiedź odmowna", "Przyjęto projekt", "W trakcie inwestycji", "Inwestycja odebrana", "Inwestycja nieodebrana", "Inne", "Przyjęto wniosek"];
      let difference = layers.filter(x => !selectedLayers.includes(x));
      this.$root.$emit('setInvestmentOpacity', difference);
    },
    changeTaskLayers(selectedLayers) {
      let layers = ["Nowe", "Zaplanowane", "Zlecone wykonanie", "W trakcie", "Zakończone"];
      let difference = layers.filter(x => !selectedLayers.includes(x));
      this.$root.$emit('setTasksOpacity', [difference, this.selectedTaskType]);
    },
    changeServitudeLayers(selectedLayers) {
      // let layers = ["Nowe", "Zaplanowane", "Zlecone wykonanie", "W trakcie", "Zakończone"];
      let difference = this.servitudeStatuses.filter(x => !selectedLayers.includes(x));
      this.$root.$emit('setServitudesOpacity', [difference, this.selectedServitudeClass]);
    },
    filterTasksTypes(taskType) {
      this.$root.$emit('setTasksVisibility', [taskType, true]);
    },
    filterServitudesClasses(servitudeClass) {
      if(servitudeClass == undefined) {
        this.$root.$emit('setServitudesVisibility', ['', false]);
        return;
      }
      let payload;
      if(servitudeClass.name == 'status') {
        payload = {
          schema: 'registry',
          table: 'transmission_easement',
          column: 'status',
          'with-subdicts': false
        };
      } else {
        payload = {
          schema: 'registry',
          table: 'transmission_easement',
          column: 'owner_type',
          'with-subdicts': false
        };
      }
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          this.servitudeStatuses = r.values;
          this.selectedServitudeStatuses = r.values;
          // this.$root.$emit('setTasksVisibility', [r.values[0], false]);
        }
      });
      this.$root.$emit('setServitudesVisibility', [servitudeClass.name, true]);
    },
    toggleInvestFilter(vis) {
      this.selectedTaskType = undefined;
      vis ? this.isInvestFilterVisible = true : this.isInvestFilterVisible = false;
    },
    toggleTasksFilter(vis) {
      this.selectedTaskType = undefined;
      vis ? this.isTasksFilterVisible = true : this.isTasksFilterVisible = false;
    },
    toggleServitudesFilter(vis) {
      this.selectedTaskType = undefined;
      vis ? this.isServitudesFilterVisible = true : this.isServitudesFilterVisible = false;
    },
    setBasemapsOpacity(val) {
      this.$store.commit('setBasemapOpacity', val);
      this.$root.$emit('setBasemapOpacity', val);
    },
    toggleStreetView() {
      this.streetViewSelection = !this.streetViewSelection;
      this.streetViewSelection
        ? this.enableStreetViewSelection()
        : this.disableStreetViewSelection();
    },
    enableStreetViewSelection() {
      // zmiana stylu buttona na "włączony"
      this.$root.$emit("enableStreetViewSelection", true);
    },
    disableStreetViewSelection() {
      // zmiana stylu buttona na "wyłączony"
      this.$root.$emit("enableStreetViewSelection", false);
    },
    openStreetView(coords) {
      this.streetViewSelection = false;
      let url =
        "https://google.com/maps?q&layer=c&cbll=" + coords[1] + "," + coords[0];
      window.open(url);
    },
    labelsVisibleToggle() {
      this.$store.commit("setLabelsShow", !this.labelsShow);
    },
    akcjaOtworzTabeleDanych() {
      if(this.tableDataActive) {
        document.querySelector('.numeric-scale__container').style.display = 'block';
      } else {
        document.querySelector('.numeric-scale__container').style.display = 'none';
      }
      this.$store.commit("setTableDataActive", !this.tableDataActive);
    },
    onInputChange: _.debounce(function (val) {
      this.clearAddrVisible = true ? val.length > 0 : this.clearAddrVisible = false;

      const self = this;
      let payload = {
        table: 'address',
        term: val
      };
      this.$store.dispatch("getObject", payload).then(r => {
        self.autocompleteListLabels = [];
        self.autocompleteList = r;
        for(let el of r) {
          self.autocompleteListLabels.push(el.label);
        }
      });
    }, 500),
    onInputChangeParcel: _.debounce(function (val) {
      val.length > 0 ? this.clearParcelsVisible = true : this.clearParcelsVisible = false;

      const self = this;
      let payload = {
        table: 'parcels',
        term: val
      };
      this.$store.dispatch("getObject", payload).then(r => {
        self.autocompleteListLabelsParcels = [];
        self.autocompleteListParcels = r;
        for(let el of r) {
          self.autocompleteListLabelsParcels.push(el.label);
        }
      });
    }, 500),
    clearAutosuggest(type) {
      if(type == 'addr') {
        this.$refs.autosuggestInput.searchInput = "";
        this.autocompleteListLabels = [];
        this.clearAddrVisible = false;
      } else {
        this.$refs.autosuggestInputParcels.searchInput = "";
        this.autocompleteListLabelsParcels = [];
        this.clearParcelsVisible = false;
      }
      this.$root.$emit("removeMarker");
    },
    showAddress(addr) {
      for(let el of this.autocompleteList) {
        if(addr.label == el.label) {
          this.$root.$emit("setPosition", [
            el.data.lat,
            el.data.lng,
            28,
            "marker"
          ]);
          break;
        }
      }
    },
    showAddressParcel(addr) {
      for(let el of this.autocompleteListParcels) {
        if(addr.label == el.label) {
          this.$root.$emit("setPosition", [
            el.data.lat,
            el.data.lng,
            28,
            "marker"
          ]);
          break;
        }
      }
    },
    setNewBookmark(tabName) {
      const self = this;
      this.$store.commit("setCurrentBookmark", tabName);
      /*setTimeout(() => {
        self.calcWidthRibbon();
      }, 100);*/

      if(tabName === "scada") {
        self.$refs.mapComponent.scadaVectorLayer.setVisible(true);
        self.$refs.mapComponent.hydranetVectorLayer.setVisible(true);
      } else {
        self.$refs.mapComponent.scadaVectorLayer.setVisible(false);
        self.$refs.mapComponent.hydranetVectorLayer.setVisible(false);
      }
      if(tabName === "modelWat") {
        self.$refs.mapComponent.virtualRecipientsLayer.setVisible(true);
        self.$refs.mapComponent.linksVectorLayer.setVisible(true);
        self.$refs.mapComponent.nodesVectorLayer.setVisible(true);
      } else {
        self.$refs.mapComponent.virtualRecipientsLayer.setVisible(false);
        self.$refs.mapComponent.linksVectorLayer.setVisible(false);
        self.$refs.mapComponent.nodesVectorLayer.setVisible(false);
      }
      if(tabName != 'management') {
        this.$root.$emit("changeLayerVisibility", {layer: 'investments', visibility: false});
        this.toggleInvestFilter(false);
      }
      if(tabName != 'tasks') {
        this.$root.$emit("changeLayerVisibility", {layer: 'tasks', visibility: false});
        this.toggleTasksFilter(false);
      }
      if(tabName != 'servitudes') {
        this.$root.$emit("changeLayerVisibility", {layer: 'transmission_easement', visibility: false});
        this.toggleServitudesFilter(false);
      }
    },
    // wrap nav elements, when the navbar is too small
    calcWidth() {
      const self = this;

      let navwidth = 0;
      let nav = document.querySelector("nav");
      let morewidth = document.querySelector("#main .more").offsetWidth;
      let navElements = document.querySelectorAll("#main > li:not(.more)");
      for(let el of navElements) {
        navwidth += el.offsetWidth;
      }
      let availablespace = nav.offsetWidth - morewidth;

      if(navwidth > availablespace) {
        let lastItem = navElements[navElements.length - 1];
        lastItem.setAttribute("data-width", lastItem.offsetWidth);

        let moreList = document.querySelector("#main .more ul");
        if(moreList.children.length == 0) {
          moreList.appendChild(lastItem);
        } else {
          moreList.insertBefore(lastItem, moreList.children[0]);
        }
        setTimeout(() => {
          self.calcWidth();
        }, 500);
      } else {
        if(document.querySelectorAll("#main li.more li").length > 0) {
          let moreElements = document.querySelectorAll("#main li.more li");
          let firstMoreElement = moreElements[0];
          if(
            navwidth + parseInt(firstMoreElement.getAttribute("data-width")) <
            availablespace
          ) {
            let main = document.querySelector("#main");
            main.insertBefore(
              firstMoreElement,
              main.childNodes[main.childNodes.length - 1]
            );
            self.calcWidth();
          }
        }
      }
      if(document.querySelectorAll(".more li").length > 0) {
        document.querySelector(".more").style.display = "inline-block";
      } else {
        document.querySelector(".more").style.display = "none";
      }
    },
    calcWidthRibbon: debounce(function () {
      let bookmark = this.currentRibbonBookmark;
      let elementsArr = document
        .querySelector(`#${bookmark}`)
        .querySelectorAll(".group:not(.hid)");
      let lastElement = elementsArr[elementsArr.length - 1];

      let lastElementLeft = lastElement.offsetLeft;
      let lastElementWidth = lastElement.offsetWidth;
      let lastElementRight = lastElementLeft + lastElementWidth;
      let navWidth = document.querySelector("#nav").offsetWidth;

      let moreWidth = document.querySelector("#showMore").offsetWidth;

      if(lastElementRight > navWidth) {
        lastElement.classList.add("hid");
        lastElement.classList.remove("group");
        lastElement.setAttribute("data-width", lastElement.offsetWidth);
        document
          .querySelector(`#${bookmark} .hidden-menu`)
          .prepend(lastElement);
        this.calcWidthRibbon();
      } else {
        if(
          document.querySelector(`#${bookmark} .hidden-menu`).children.length >
          0
        ) {
          let firstHidden = document.querySelector(`#${bookmark} .hidden-menu`)
            .children[0];
          if(
            navWidth - lastElementRight - moreWidth >
            firstHidden.getAttribute("data-width")
          ) {
            firstHidden.classList.remove("hid");
            firstHidden.classList.add("group");

            let showMore = document.querySelector(`#${bookmark} #showMore`);

            let groupWrapper = document.querySelector(`#${bookmark} > div`);
            groupWrapper.insertBefore(
              firstHidden,
              groupWrapper.childNodes[groupWrapper.childNodes.length - 1]
            );
            this.calcWidthRibbon();
          }
        }
      }
      let showMoreBtn = document.querySelector("#showMore");
      if(document.querySelector(`#${bookmark} .hidden-menu`).hasChildNodes()) {
        showMoreBtn.style.display = "block";
      } else {
        showMoreBtn.style.display = "none";
      }
    }, 500),
    logout() {
      this.$store.dispatch("logout").then(r => {
        this.$store.commit("setCurrentBookmark", "");
        this.$router.push({name: "login"});
        delete localStorage.accesstoken;
      });
    },
    triggerDialog(val) {
      this.isConfDialogActive = val;
    },

    calcWidthRibbonScroll: debounce(function () {
      let bookmark = this.currentRibbonBookmark;
      if(this.$refs[bookmark]) {
        this.$refs[bookmark].$refs["bar-element"].update();
      }
    }, 500),

    expandTabs() {
      this.expandTabsState = !this.expandTabsState;
      this.$nextTick(() => {
        this.map.updateSize();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/Viewer.vue